const features = [
  {
    icon: 'ri-global-line',
    title: '韩网同步更新',
    desc: '与韩国原版平台同步更新，最快30分钟内上线中文译版，确保你第一时间读到最新章节',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费阅读',
    desc: '平台所有韩漫资源永久免费，无需付费订阅，无需购买点数，打开即读，畅享无阻',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '支持电脑、平板和手机浏览器访问，自适应排版优化，随时随地享受流畅的韩漫阅读体验',
  },
  {
    icon: 'ri-folder-open-line',
    title: '海量作品库',
    desc: '收录超过5000部韩漫作品，涵盖恋爱、奇幻、动作、悬疑、日常等全品类题材，持续扩充中',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          为什么选择我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          用心打造最优质的韩漫在线阅读平台
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-6 md:p-7 border border-background-200/70 transition-all duration-300 hover:border-primary-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}